import { PetEvolutionStage } from 'src/replicant/pet';
import * as Pet from 'src/replicant/pet';
import { PetModel } from './PetModel';
import StateObserver from 'src/StateObserver';

export class FriendPetModel implements PetModel {
  public state() {
    const { user, pet } = StateObserver.getState();
    const currentPet = pet[this.id];

    // Pet not initialized yet, return normal state.
    if (!currentPet) return 'normal';

    // Infer state from pet attributes and status effects.
    return Pet.ruleset.getPetState(
      currentPet.attributes,
      currentPet.statusEffects,
      !!user.visit.visitSession,
    );
  }

  public species() {
    const { pet } = StateObserver.getState();
    return pet[this.id]?.species;
  }

  public stage() {
    return this._stage;
  }
  public features() {
    return this._features;
  }

  public decorations() {
    return this._decorations;
  }

  constructor(
    private id: string,
    private _stage: PetEvolutionStage,
    private _features: ReturnType<PetModel['features']>,
    private _decorations: ReturnType<PetModel['decorations']>,
  ) {}
}
